import { useState, useEffect } from 'react';

const NIGERIAN_WOMEN: string[] = [
  'Lady Oyinkansola Kofo-Abayomi',
  'Lady Charlotte Obasa',
  'Madam Alimotu Pelewura',
  'Madame Rabiatu Iyalode (Alaso)',
  'Miss Tinuola Dedeke',
  'Miss Ayo Manuwa',
  'Lady Kofoworola Moore (Lady Ademola)',
  'Stella Jane Thomas',
  'Miss Fola Akintunde-Ighodalo',
  'Adebisi Adedoyin-Adebiyi',
  'Miss Victoria Omolara Bucknor',
  'Princess Adenrele & Adeyombo Ademola',
  'Ebun Moore',
  'Kofoworola Abeni Pratt',
  'Bisi & Aduke Alakija',
  'Miss Iren Welleseley-Cole (Ighodaro)',
];

const HONORIFICS: string[] = [
  'Trailblazer',
  'Daughter of Nigeria',
  'She Who Dared',
  'A Woman of History',
];

export default function AnimatedNames() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        setCurrentIndex((prev) => (prev + 1) % NIGERIAN_WOMEN.length);
        setVisible(true);
      }, 600);
    }, 3500);
    return () => clearInterval(interval);
  }, []);

  const current = NIGERIAN_WOMEN[currentIndex];
  const honorific = HONORIFICS[currentIndex % HONORIFICS.length];

  return (
    <div className="relative w-full h-full flex flex-col items-center justify-center px-5 sm:px-8 py-8 sm:py-10">
      {/* Decorative top line */}
      <div className="w-12 h-0.5 bg-gold mb-5 animate-pulse_gold" />

      {/* Cycling count indicator */}
      <div className="flex gap-1.5 mb-6">
        {NIGERIAN_WOMEN.map((_, i) => (
          <div
            key={i}
            className="w-1.5 h-1.5 rounded-full transition-all duration-500"
            style={{
              backgroundColor: i === currentIndex ? '#D4AF37' : 'rgba(212,175,55,0.3)',
              transform: i === currentIndex ? 'scale(1.4)' : 'scale(1)',
            }}
          />
        ))}
      </div>

      {/* Animated Name + Honorific */}
      <div
        className="text-center transition-all duration-500"
        style={{
          opacity: visible ? 1 : 0,
          transform: visible ? 'translateY(0) scale(1.02)' : 'translateY(12px) scale(0.98)',
        }}
      >
        {/* Honorific title */}
        <p
          className="font-sans uppercase tracking-[0.25em] mb-3 font-medium"
          style={{ color: '#D4AF37', fontSize: '0.65rem', letterSpacing: '0.3em' }}
        >
          {honorific}
        </p>

        {/* Thin gold rule */}
        <div
          className="mx-auto mb-3"
          style={{
            width: '2.5rem',
            height: '1px',
            background: 'linear-gradient(90deg, transparent, #D4AF37, transparent)',
          }}
        />

        <h2
          className="font-serif text-cream leading-tight"
          style={{ fontSize: 'clamp(1.5rem, 5vw, 2.6rem)' }}
        >
          {current}
        </h2>
      </div>

      {/* Decorative bottom line */}
      <div className="w-12 h-0.5 bg-gold mt-5 animate-pulse_gold" />

      {/* Corner decorations */}
      <div className="absolute top-4 left-4 w-5 h-5 border-t-2 border-l-2 border-gold/50 rounded-tl" />
      <div className="absolute top-4 right-4 w-5 h-5 border-t-2 border-r-2 border-gold/50 rounded-tr" />
      <div className="absolute bottom-4 left-4 w-5 h-5 border-b-2 border-l-2 border-gold/50 rounded-bl" />
      <div className="absolute bottom-4 right-4 w-5 h-5 border-b-2 border-r-2 border-gold/50 rounded-br" />
    </div>
  );
}
